/**
 * @readonly
 * @enum {string}
 */
export const TpmsReceiverTypes = Object.freeze({
    BLUETOOTH: 'BLUETOOTH',
    CAN: 'CAN',
    HUF: 'HUF',
    STE_MASTER: 'STE_MASTER',
    STE_SLAVE: 'STE_SLAVE'
})
